// extracted by mini-css-extract-plugin
export default {"cell":"NegStatusCell_cell__7BoOP","escalated":"NegStatusCell_escalated__XU0j7","counteroffer":"NegStatusCell_counteroffer__feEnZ","accepted":"NegStatusCell_accepted__S9Tiw"};